<div class="dtf-accountdetails">
<mat-dialog-content>
  @if(this.amortdialog ==='error'){
    <h2><b>Error</b></h2>
    <p><b>{{errorMessage}}</b></p>
  }
 </mat-dialog-content>
<mat-dialog-actions>
  @if(this.amortdialog ==='error'){
    <button mat-button mat-dialog-close>Continue</button>
  }
</mat-dialog-actions>
</div>